import { combineReducers } from '@reduxjs/toolkit';

import profilesReducer from './profileSlice';
import printProfilesReducer from './printProfileSlice';
import downloadProfilesReducer from './downloadProfileSlice';

const reducer = combineReducers({
  profile: profilesReducer,
  printProfile: printProfilesReducer,
  downloadProfile: downloadProfilesReducer,
});
export default reducer;
